import React, { useState, useMemo, useCallback, useEffect } from "react";
import { baseURL } from "../../constants/pathnames";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ModalReportDetail from "./ModalReportDetail";
import Table from "../Table/Table";

const Reports = (props) => {
  const { token } = useSelector((state) => state.users);
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);
  const history = useHistory();
  const [issearchinput, setIsSearchinput] = useState(false);
  const [searchinput, setSearchinput] = useState("");
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [activestatus, setActivestatus] = useState(null);
  const [isModalProductDetail, setIsModalProductDetail] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [next, setNext] = useState(null);

  const columns = [
    { Header: "کد آگهی", accessor: "code" },
    { Header: "نام آگهی", accessor: "title" },
    { Header: "نام و نام خانوادگی", accessor: "fullname" },
    // { Header: "تاریخ", accessor: "date" },
    { Header: "شهر", accessor: "city" },
    { Header: "جزییات", accessor: "detail" },
  ];

  const getdata = useCallback(() => {
    debugger;
    // ${"?search=" + searchinput}${
    //       activestatus ? "&offer_status=" + activestatus?.id : ""
    //     }
    axios
      .get(`${baseURL}report/?report__report_type=1`, header)
      .then((res) => {
        console.log(res.data);
        // setNext(res.data.next);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [header, searchinput, activestatus]);
  useEffect(() => {
    getdata();
  }, [getdata]);

  const getNextList = () => {
    debugger;
    if (next != null) {
      axios
        .get(next, header)
        .then((res) => {
          console.log("res", res.data);
          setData([...data, ...res.data.results]);
          setNext(res.data.next);
        })
        .catch((err) => {
          console.log("err", err.response);
        });
    }
  };

  useEffect(() => {
    debugger;
    // console.log(state);
    const newArray = [];
    for (let i = 0; i < data?.length; i++) {
      const tr = data[i];
      newArray.push({
        code: tr?.id,
        title: (
          <div
            className='cursor color-blue'
            onClick={() => {
              history.push("/adsdetail/" + tr?.reported_product_id);
            }}
          >
            {tr?.reported_product}
          </div>
        ),
        fullname: tr?.product_owner,
        // date: moment(tr?.created_time).locale("fa").format("YYYY/MM/DD"),
        city: tr?.city,
        detail: (
          <>
            <img
              className='mx-auto cursor-pointer'
              src='/statics/images/eye.png'
              width='20'
              alt='eye'
              onClick={() => {
                setModalData(tr);
                setIsModalProductDetail(true);
                // history.push("/requestdetail/" + tr?.id);
              }}
            />
          </>
        ),
      });
    }

    setRows(newArray);
  }, [data]);

  return (
    <div>
      <div className='flex justify-end items-center gap-3 h-16 mb-8'>
        {/* search */}
        {/* <div
          className={`m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center${
            issearchinput ? "flex justify-between items-center w-64" : ""
          } `}
        >
          {issearchinput && (
            <input
              // className='transition-all'
              placeholder='جست و جوی کالا'
              defaultValue={searchinput}
              // value={filters?.search}
              onChange={(e) => {
                const { value } = e.target;
                setSearchinput(value);
              }}
            />
          )}
          <img
            // className='transition-all'
            src='/statics/images/search.svg'
            width='16'
            alt='eye'
            onClick={() => {
              setIsSearchinput(!issearchinput);
            }}
          />
        </div> */}

        {/* bell */}
        {/* <div className='m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center'>
          <img
            className=''
            src='/statics/images/bell.svg'
            width='16'
            alt='bell'
          />
        </div> */}
      </div>

      <div className='rounded-lg shadow mx-1 p-2'>
        <InfiniteScroll
          className='w-100'
          dataLength={data?.length}
          next={() => getNextList()}
          hasMore={true}
          scrollableTarget='scrollableDiv'
        >
          <div
            className='overflow-y-scroll scroll-style pr-2 ltr h-full '
            id='scrollableDiv'
            style={{ height: "60vh" }}
          >
            <div className='rtl m-5 md:m-0'>
              <Table
                classs='paneltable UsersTable'
                columns={columns}
                data={rows}
                hasSpace
              />
            </div>
          </div>
        </InfiniteScroll>
      </div>

      {isModalProductDetail && (
        <ModalReportDetail
          onCancel={() => setIsModalProductDetail(!isModalProductDetail)}
          data={modalData}
          getdata={getdata}
        />
      )}
    </div>
  );
};

export default Reports;
